import React from 'react';
import { useListingPriceFairness } from '@/hooks/useListingPriceFairness';
import { TrendingDown, TrendingUp, Check } from 'lucide-react';

interface Props {
  listingId: string;
}

export const PriceFairnessBadge: React.FC<Props> = ({ listingId }) => {
  const { data } = useListingPriceFairness(listingId);

  if (!data || data.fairness_label === 'unknown') return null;

  const config = {
    good: {
      label: 'Preț bun în piață',
      icon: <TrendingDown className="h-3.5 w-3.5" />,
      cls: 'bg-brand-green/10 text-brand-green border-brand-green/30',
    },
    fair: {
      label: 'Preț corect',
      icon: <Check className="h-3.5 w-3.5" />,
      cls: 'bg-secondary text-secondary-foreground border-border',
    },
    high: {
      label: 'Peste media pieței',
      icon: <TrendingUp className="h-3.5 w-3.5" />,
      cls: 'bg-brand-gold/15 text-foreground border-brand-gold/40',
    },
  }[data.fairness_label]!;

  const tooltip = `Mediană ${Math.round(data.median_price).toLocaleString('ro-RO')} € pentru același model + an ±1 (${data.sample_size} anunțuri comparabile)`;

  return (
    <span
      title={tooltip}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${config.cls}`}
    >
      {config.icon}
      {config.label}
      {data.delta_pct !== null && (
        <span className="opacity-70">({data.delta_pct > 0 ? '+' : ''}{data.delta_pct}%)</span>
      )}
    </span>
  );
};
